import { type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEntityPreview } from '../../hooks/useEntityPreview';
import { EntityCard } from './EntityCard';

interface EntityLinkProps {
  type: 'contact' | 'company';
  id: string;
  children: ReactNode;
}

export function EntityLink({ type, id, children }: EntityLinkProps) {
  const navigate = useNavigate();
  const { data, loading, visible, show, hide } = useEntityPreview();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (type === 'contact') navigate(`/contacts/${id}`);
    // Companies don't have a detail page yet
  };

  return (
    <span
      className="relative inline-block"
      onMouseEnter={() => show(type, id)}
      onMouseLeave={hide}
    >
      <button
        onClick={handleClick}
        className="text-left text-nexus-400 hover:text-nexus-300 hover:underline transition-colors cursor-pointer"
      >
        {children}
      </button>
      {visible && (
        <div className="absolute z-50 top-full left-0 mt-1 rounded-xl border border-surface-600 bg-surface-800 shadow-xl">
          <EntityCard data={data} type={type} loading={loading} />
        </div>
      )}
    </span>
  );
}
